import React from "react";
 function RegisterSeparator(){
    return(
        
        <div className="seperator"><b>or</b></div>
    )
 }

 export default RegisterSeparator;